module.exports = __webpack_public_path__ + "img/pie-chart-third.2a5b5b0f.svg";